import * as React from 'react'

const Micro = ({
  title,
  titleId,
  ...props
}: {
  title?: string
  titleId?: string
} & React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="#400099"
    focusable={false}
    aria-hidden
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M12.75 17.344v3.149h1.487a.75.75 0 110 1.5h-4.49a.75.75 0 010-1.5h1.503v-3.15a5.751 5.751 0 01-5-5.7V8a.75.75 0 011.5 0v3.642a4.25 4.25 0 108.5 0V8a.75.75 0 111.5 0v3.642a5.751 5.751 0 01-5 5.702zM12 3.75a1.75 1.75 0 00-1.75 1.75v6a1.75 1.75 0 003.5 0v-6A1.75 1.75 0 0012 3.75zm0-1.5a3.25 3.25 0 013.25 3.25v6a3.25 3.25 0 01-6.5 0v-6A3.25 3.25 0 0112 2.25z" />
  </svg>
)

export default Micro
